import React from 'react'
import {Button} from 'react-bootstrap'
import '../Styles/cabezera.css'

const cabezera = () => {
    return ( 
        <div className="cabezera" id="INIT">
            <h1>BePack</h1>
            <hr/>
            <h2>Opta por ideas renovables, genera grandes cambios para la vida y el planeta </h2>
            <Button variant="success" href="#FORMULARIO">Contactar</Button> 
        </div>
     );
}
 
export default cabezera;